import { Point, IPhysicalObject } from '.';
import { Gravity } from '../physics';
/**
 * @abstract
 */
export abstract class PhysicalObject {
public x: number;
public y: number;
public width: number;
public height: number;
public radius?: number;
public solid: boolean;
public px: number;
public py: number;
public gravity: Gravity;
/**
 * @param {?} x
 * @param {?} y
 * @return {?}
 */
public move(x: number, y: number): void {
    this.px = this.x;
    this.py = this.y;
    this.x += x;
    this.y += y;
  }
/**
 * @return {?}
 */
public toPrevious(): void {
    this.x = this.px;
    this.y = this.py;
  }
/**
 * @abstract
 * @param {?} point
 * @return {?}
 */
pointInside(point: Point) {}
/**
 * @abstract
 * @param {?} shape
 * @return {?}
 */
intersect(shape: IPhysicalObject) {}
}

function PhysicalObject_tsickle_Closure_declarations() {
/** @type {?} */
PhysicalObject.prototype.x;
/** @type {?} */
PhysicalObject.prototype.y;
/** @type {?} */
PhysicalObject.prototype.width;
/** @type {?} */
PhysicalObject.prototype.height;
/** @type {?} */
PhysicalObject.prototype.radius;
/** @type {?} */
PhysicalObject.prototype.solid;
/** @type {?} */
PhysicalObject.prototype.px;
/** @type {?} */
PhysicalObject.prototype.py;
/** @type {?} */
PhysicalObject.prototype.gravity;
}
